import React from 'react';
import {type FitmentRuntimeConfig} from './FitmentSelector';
import MyAccountPageShell from './MyAccountPageShell';
import ProductSearchForm, {
    type ProductSearchFormProps,
    type ProductSearchUiSettings,
} from './ProductSearchForm';

interface FitmentToolPageProps extends ProductSearchFormProps {
    fitmentTool?: FitmentRuntimeConfig;
    fitmenttool?: FitmentRuntimeConfig;
    products_path?: string;
    productspath?: string;
    productsPath?: string;
}

const FITMENT_PAGE_UI_SETTINGS: ProductSearchUiSettings = {
    header_title: 'Fitment',
    hide_header_subtitle: true,
};

const FitmentToolPage: React.FC<FitmentToolPageProps> = ({
    fitmentTool,
    fitmenttool,
    products_path: _productsPath,
    productspath: _legacyProductsPath,
    productsPath: _camelProductsPath,
    uiSettings,
    ...searchProps
}) => {
    const fitmentToolConfig = fitmentTool || fitmenttool;
    const hasConfiguredAttributes = (
        fitmentToolConfig?.enabled === true
        && Array.isArray(fitmentToolConfig.attributes)
        && fitmentToolConfig.attributes.length > 0
    );

    if (!hasConfiguredAttributes) {
        return (
            <MyAccountPageShell
                id="weka-content"
                className="find-products-container fitment-tool-page"
                title="Fitment"
            >
                <div className="woocommerce-info mb-0">
                    No fitment attributes have been configured yet.
                </div>
            </MyAccountPageShell>
        );
    }

    return (
        <ProductSearchForm
            {...searchProps}
            fitmentTool={fitmentToolConfig}
            {...(uiSettings ? {uiSettings} : {})}
            uiSettingsOverride={FITMENT_PAGE_UI_SETTINGS}
            forceFitmentSelector={true}
        />
    );
};

export default FitmentToolPage;
